import types from "./types";
import StoreTypes from "../../../store/types";

const initialState = {
  partnerFirstName: "",
  partnerMiddleName: "",
  partnerLastName: "",
  partnerTitle: "",
  partnerGender: "",
  partnerEmail: "",
  planForPartner: {
    status: false,
  },
  children: [],
  pets: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BASIC_INFO:
      return { ...state, children: action.payload };

    case types.PARTNER_GENDER:
      return { ...state, partnerGender: action.payload };

    case types.PARTNER_INFO:
      return {
        ...state,
        partnerFirstName: action.payload.partnerFirstName,
        partnerMiddleName: action.payload.partnerMiddleName,
        partnerLastName: action.payload.partnerLastName,
        partnerTitle: action.payload.partnerTitle,
      };

    case types.PARTNER_PLAN:
      return { ...state, planForPartner: action.payload };

    case StoreTypes.SET_DETAILS:
      return {
        ...state,
        children: action.payload.family?.children,
        pets: action.payload.family?.pets,
        partnerFirstName: action.payload.family?.partnerFirstName,
        partnerMiddleName: action.payload.family?.partnerMiddleName,
        partnerLastName: action.payload.family?.partnerLastName,
        partnerTitle: action.payload.family?.partnerTitle,
        partnerGender: action.payload.family?.partnerGender,
        partnerEmail: action.payload.family?.partnerEmail,
        planForPartner: action.payload.family?.planForPartner,
      };

    case types.PETS_INFO:
      return { ...state, pets: action.payload };

    default:
      return state;
  }
};

export default reducer;
